<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title {{cssClass}}">{{title}}</h4>
    </div>
    <div class="modal-body">
        <p [innerHtml]="body"></p>
        <p *ngIf="extra" class="{{cssClass}}" [innerHtml]="extra"></p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="activeModal.close(true)">{{buttonText}}</button>
    </div>
</div>